import type { UpdateShopOverrideRuleDto, ShopOverrideRuleDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

interface UseUpdateShopOverrideRulesParams {
	onSuccess?: (data: ShopOverrideRuleDto[]) => void;
}

export default function useUpdateShopOverrideRules(
	shopId: string,
	options?: UseUpdateShopOverrideRulesParams,
) {
	return useApiMutation("patch", "/shops/{shopId}/override-rules", {
		onSuccess: options?.onSuccess,
		mapVariables: (requestBody: UpdateShopOverrideRuleDto[]) => ({
			params: { path: { shopId } },
			body: requestBody,
		}),
	});
}